import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import agent from "../../agent";

import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import Loading from "../../components/loadingSpinner/Loading";
import StatCard from "../../components/dashboard/StatCard";
import GigStatsCard from "../../components/dashboard/GigStatsCard";
import CommissionBreakdown from "../../components/dashboard/CommissionBreakdown";
import NeedsAttention from "../../components/dashboard/NeedsAttention";
import VenueInvitationModal from "../../components/agent/venueRoster/VenueInvitationModal";
import ActInvitationModal from "../../components/util/ActInvitation/ActInvitationModal";
import ActOwnerInvitationModal from "../../components/util/ActOwnerInvitation/ActOwnerInvitationModal";
import { ProfileType } from "../../types/enum"
import moment from "moment"
import _ from "lodash";

import { Select, MenuItem, IconButton } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "material-ui-pickers";
import MomentUtils from "@date-io/moment";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import EventIcon from "@material-ui/icons/Event";

import "../../components/dashboard/AgentDashboard.css";

@inject("profileStore", "templateStore", "profileStore", "agentActStore", "bookingRequestStore")
@observer
class Agent extends Component {
    state = {
        data: {},
        startDate: moment().startOf("isoWeek"),
        endDate: moment().endOf("isoWeek"),
        firstDay: null,
        lastDay: null,
        isLoading: true,
        filterType: "week",
        draftBookings: 0,
        negotiateBookings: 0,
        pendingResponses: 0,
        cancelledBookings: 0,
        declinedBookings: 0,
        totalGigs: 0,
        sentUpcoming: 0,
        completedGigs: 0,
        venueInvitationModalOpen: false,
        actOwnerInvitationModalOpen: false
    };

    openVenueInvitationModal = () => {
        this.setState({ venueInvitationModalOpen: true });
    };

    closeVenueInvitationModal = () => {
        this.setState({ venueInvitationModalOpen: false });
    };

    openActInvitationModal = () => {
        this.props.agentActStore.openActInvitationModal();
    };

    closeActInvitationModal = () => {
        this.props.agentActStore.closeActInvitationModal();
    };

    openActOwnerInvitationModal = () => {
        this.setState({ actOwnerInvitationModalOpen: true });
    };

    closeActOwnerInvitationModal = () => {
        this.setState({ actOwnerInvitationModalOpen: false });
        this.props.agentActStore.closeActInvitationModal();
    };

    currentProfileId = 0;
    offset = moment(new Date()).utcOffset()
    
    loadData = () => {
        this.setState({ isLoading: true });
        Promise.all([
            agent.Profile.getAgentDashboardMain(
                this.currentProfileId,
                this.state.firstDay,
                this.state.lastDay,
                0,
                0
            ),
            agent.Profile.getAgentDashboardVenue(
                this.currentProfileId,
                this.state.firstDay,
                this.state.lastDay,
                0,
                0
            ),
        ])
        .then(result => {
            var data = result[0];
            var venues = result[1];

            for (var i = 0; i < venues.length; i++) {
                var comp = venues[i];
                comp.nameString = comp.name.toUpperCase()
            }
            venues = _.orderBy(venues, "nameString")
            data.venues = venues;

            this.setState({ 
                data: data,
                draftBookings: data.draftCount || 0,
                negotiateBookings: data.negotiationCount || 0,
                pendingResponses: data.pendingResponseCount || 0,
                cancelledBookings: data.cancelledBookings || 0,
                declinedBookings: data.declinedCount || 0,
                totalGigs: data.totalCount || 0,
                sentUpcoming: data.upcomingCount || 0,
                completedGigs: data.completedBooking || 0,
                isLoading: false 
            });
        });
    };

    formatDate = date => {
        let d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [year, month, day].join("-");
    };

    gotoDashboard(profileType) {
        switch (profileType) {
            case 1:
                this.props.history.replace("/musician");
                break;
            case 2:
                this.props.history.replace("/agent");
                break;
            case 3:
                this.props.history.replace("/staff");
                break;
            case 6:
                this.props.history.replace("/production");
                break;
            case 7:
                this.props.history.replace("/dj");
                break;
            case 8:
                this.props.history.replace("/agent");
                break;
            case 9:
                this.props.history.replace("/privatehire/gig");
                break;
            default:
                break;
        }
    }

    componentDidMount = () => {
        var currentProfile = this.props.profileStore.getCurrentProfile();

        this.currentProfileId = currentProfile.id;
        if(currentProfile.type !== ProfileType.Agent.ordinal){
            this.gotoDashboard(currentProfile.type)
        }
        
        const { startDate, endDate } = this.state;
        const firstDay = this.formatDate(startDate.toDate()) + " 00:00:00";
        const lastDay = this.formatDate(endDate.toDate()) + " 23:59:59.999";

        this.setState({ firstDay: firstDay, lastDay: lastDay }, () => {
            this.loadData();
        });
    };

    onFilterTypeChange = (e) => {
        const value = e.target.value;
        this.setState({ filterType: value });
        
        if (value === "today") {
            const today = moment();
            this.setState({
                startDate: today,
                endDate: today,
                firstDay: this.formatDate(today.toDate()) + " 00:00:00",
                lastDay: this.formatDate(today.toDate()) + " 23:59:59.999"
            }, () => this.loadData());
        } else if (value === "week") {
            const startDate = moment().startOf("isoWeek");
            const endDate = moment().endOf("isoWeek");
            this.setState({
                startDate,
                endDate,
                firstDay: this.formatDate(startDate.toDate()) + " 00:00:00",
                lastDay: this.formatDate(endDate.toDate()) + " 23:59:59.999"
            }, () => this.loadData());
        } else if (value === "lastweek") {
            const startDate = moment().subtract(1, 'week').startOf("isoWeek");
            const endDate = moment().subtract(1, 'week').endOf("isoWeek");
            this.setState({
                startDate,
                endDate,
                firstDay: this.formatDate(startDate.toDate()) + " 00:00:00",
                lastDay: this.formatDate(endDate.toDate()) + " 23:59:59.999"
            }, () => this.loadData());
        } else if (value === "monthly") {
            const startDate = moment().startOf("month");
            const endDate = moment().endOf("month");
            this.setState({
                startDate,
                endDate,
                firstDay: this.formatDate(startDate.toDate()) + " 00:00:00",
                lastDay: this.formatDate(endDate.toDate()) + " 23:59:59.999"
            }, () => this.loadData());
        } else if (value === "custom") {
            const startDate = moment().startOf("month");
            const endDate = moment().endOf("month");
            this.setState({
                startDate,
                endDate,
                firstDay: this.formatDate(startDate.toDate()) + " 00:00:00",
                lastDay: this.formatDate(endDate.toDate()) + " 23:59:59.999"
            }, () => this.loadData());
        }
    };

    onChangeMonth = (value) => {
        const startDate = moment(value).startOf("month");
        const endDate = moment(value).endOf("month");
        this.setState({
            startDate,
            endDate,
            firstDay: this.formatDate(startDate.toDate()) + " 00:00:00",
            lastDay: this.formatDate(endDate.toDate()) + " 23:59:59.999"
        }, () => this.loadData());
    };

    onPrevMonth = () => {
        const { startDate } = this.state;
        const prevMonth = moment(startDate).subtract(1, 'month');
        this.onChangeMonth(prevMonth);
    };

    onNextMonth = () => {
        const { startDate } = this.state;
        const nextMonth = moment(startDate).add(1, 'month');
        this.onChangeMonth(nextMonth);
    };

    onChangeStartDate = (value) => {
        const { endDate } = this.state;
        const startDate = moment(value);
        if (startDate.isAfter(endDate)) {
            this.setState({
                startDate,
                endDate: startDate,
                firstDay: this.formatDate(startDate.toDate()) + " 00:00:00",
                lastDay: this.formatDate(startDate.toDate()) + " 23:59:59.999"
            }, () => this.loadData());
        } else {
            this.setState({
                startDate,
                firstDay: this.formatDate(startDate.toDate()) + " 00:00:00"
            }, () => this.loadData());
        }
    };

    onChangeEndDate = (value) => {
        const { startDate } = this.state;
        const endDate = moment(value);
        if (endDate.isBefore(startDate)) {
            this.setState({
                startDate: endDate,
                endDate,
                firstDay: this.formatDate(endDate.toDate()) + " 00:00:00",
                lastDay: this.formatDate(endDate.toDate()) + " 23:59:59.999"
            }, () => this.loadData());
        } else {
            this.setState({
                endDate,
                lastDay: this.formatDate(endDate.toDate()) + " 23:59:59.999"
            }, () => this.loadData());
        }
    };

    render() {
        const { 
            isLoading, 
            data, 
            filterType, 
            draftBookings, 
            negotiateBookings, 
            pendingResponses,
            cancelledBookings,
            declinedBookings,
            totalGigs,
            sentUpcoming,
            completedGigs,
            startDate, 
            endDate 
        } = this.state;
        const { currentProfile } = this.props.profileStore;
        const currencySymbol = currentProfile?.currencySymbol || "$";
        const dateFormat = "DD-MM-YYYY";
        const monthFormat = "MMM YYYY";

        return (
            <div>
                <Header />
                <Sidebar />
                <MainContainer>
                    <div className="agent-dashboard">
                        <div className="agent-dashboard-hero">
                            <div className="agent-dashboard-header">
                                <h1>Dashboard</h1>
                                <div className="agent-dashboard-header-actions">
                                    <button onClick={this.openActInvitationModal} className="agent-dashboard-btn agent-dashboard-btn-ghost">
                                        <i className="fa fa-user-plus"></i>
                                        <span>Invite Act</span>
                                    </button>
                                    <button onClick={this.openVenueInvitationModal} className="agent-dashboard-btn agent-dashboard-btn-ghost">
                                        <i className="fa fa-building"></i>
                                        <span>Add Venue</span>
                                    </button>
                                    <Link to="/invoice" className="agent-dashboard-btn agent-dashboard-btn-ghost">
                                        <i className="fa fa-file-invoice-dollar"></i>
                                        <span>Invoices</span>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="agent-dashboard-filter-bar agent-dashboard-filter-bar--dark">
                            <div className="agent-dashboard-filter-group">
                                <span className="agent-dashboard-filter-label">Showing</span>
                                <Select
                                    value={filterType}
                                    onChange={this.onFilterTypeChange}
                                    className="dark-select slim-select-input"
                                    classes={{
                                        root: "text-white",
                                        icon: "text-white"
                                    }}
                                >
                                    <MenuItem value="today">Today</MenuItem>
                                    <MenuItem value="week">This Week</MenuItem>
                                    <MenuItem value="lastweek">Last Week</MenuItem>
                                    <MenuItem value="monthly">Month</MenuItem>
                                    <MenuItem value="custom">Custom</MenuItem>
                                </Select>
                            </div>
                            
                            {filterType === "monthly" && (
                                <div className="agent-dashboard-filter-group">
                                    <IconButton 
                                        onClick={this.onPrevMonth}
                                        size="small"
                                        className="agent-dashboard-filter-nav-btn"
                                    >
                                        <KeyboardArrowLeftIcon />
                                    </IconButton>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            views={["year", "month"]}
                                            value={startDate}
                                            onChange={this.onChangeMonth}
                                            format={monthFormat}
                                            className="dark-datepicker slim-month-input"
                                            autoOk
                                            keyboardIcon={<EventIcon />}
                                            leftArrowIcon={<KeyboardArrowLeftIcon />}
                                            rightArrowIcon={<KeyboardArrowRightIcon />}
                                            InputProps={{
                                                classes: {
                                                    root: "text-white"
                                                }
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                    <IconButton 
                                        onClick={this.onNextMonth}
                                        size="small"
                                        className="agent-dashboard-filter-nav-btn"
                                    >
                                        <KeyboardArrowRightIcon />
                                    </IconButton>
                                </div>
                            )}
                            
                            {filterType === "custom" && (
                                <div className="agent-dashboard-filter-group">
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            emptyLabel="From"
                                            value={startDate}
                                            onChange={this.onChangeStartDate}
                                            format={dateFormat}
                                            className="dark-datepicker slim-month-input"
                                            keyboardIcon={<EventIcon />}
                                            leftArrowIcon={<KeyboardArrowLeftIcon />}
                                            rightArrowIcon={<KeyboardArrowRightIcon />}
                                            InputProps={{
                                                classes: {
                                                    root: "text-white"
                                                }
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                    <span className="agent-dashboard-date-separator">to</span>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            emptyLabel="To"
                                            value={endDate}
                                            onChange={this.onChangeEndDate}
                                            format={dateFormat}
                                            className="dark-datepicker slim-month-input"
                                            keyboardIcon={<EventIcon />}
                                            leftArrowIcon={<KeyboardArrowLeftIcon />}
                                            rightArrowIcon={<KeyboardArrowRightIcon />}
                                            InputProps={{
                                                classes: {
                                                    root: "text-white"
                                                }
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            )}
                        </div>

                        <div style={{ position: "relative" }}>
                            {isLoading && <div className="agent-dashboard-loading-overlay"><Loading showed={true} /></div>}

                            <div className="agent-dashboard-stats-grid">
                                <StatCard
                                    icon="fa fa-dollar-sign"
                                    value={`${currencySymbol}${(data.totalGigFees || 0).toLocaleString()}`}
                                    label="Total Gig Fees"
                                    isPrimary={true}
                                    isLoading={isLoading}
                                />
                                <StatCard
                                    icon="fa fa-hand-holding-usd"
                                    iconColor="green"
                                    value={`${currencySymbol}${(data.totalCommissionEarned || 0).toLocaleString()}`}
                                    label="Commission Earned"
                                    isLoading={isLoading}
                                />
                                <GigStatsCard
                                    totalGigs={totalGigs}
                                    sentUpcoming={sentUpcoming}
                                    completed={completedGigs}
                                    isLoading={isLoading}
                                />
                            </div>

                            <div className="agent-dashboard-main-grid">
                                <CommissionBreakdown 
                                    consultantBreakdown={data.consultantBreakdown || []}
                                    currencySymbol={currencySymbol}
                                />

                                <NeedsAttention 
                                    draftBookings={draftBookings}
                                    pendingResponses={pendingResponses}
                                    negotiateBookings={negotiateBookings}
                                    cancelledBookings={cancelledBookings}
                                    declinedBookings={declinedBookings}
                                />
                            </div>
                        </div>
                    </div>
                </MainContainer>

                <VenueInvitationModal 
                    open={this.state.venueInvitationModalOpen} 
                    onClose={this.closeVenueInvitationModal} 
                />

                <ActInvitationModal
                    open={this.props.agentActStore.actInvitationModalState}
                    onClose={this.closeActInvitationModal}
                    profileType="agent"
                    handleEmpty={this.openActOwnerInvitationModal}
                />

                <ActOwnerInvitationModal 
                    open={this.state.actOwnerInvitationModalOpen} 
                    onClose={this.closeActOwnerInvitationModal} 
                />
            </div>
        );
    }
}
export default Agent;
